import { useEffect } from 'react';
import { GlobalSettingEnum } from 'api/model';
import { setBreakOnTopPlanningFromDate } from 'utils/breakOnTopPlanning';
import useGlobalSettings from './useGlobalSettings';

/**
 * Keeps the module-level "break on top in planning" rollout date (utils/breakOnTopPlanning) in sync with the
 * global setting `BreakAddedToEstimatedDurationFromDate` (editable at /settings/globala-installningar).
 *
 * Mount once high in the case-detail tree (DetailedCaseFormProvider) so the pure form-serialization helpers
 * and the EstimatedAssignmentTimeValue display read the configured date. When the setting is unset/empty the
 * feature stays off (legacy planning).
 */
const useBreakOnTopPlanningSetting = (): void => {
  const { globalSettings } = useGlobalSettings();

  useEffect(() => {
    setBreakOnTopPlanningFromDate(
      globalSettings[GlobalSettingEnum.BreakAddedToEstimatedDurationFromDate]
    );
  }, [globalSettings]);
};

export default useBreakOnTopPlanningSetting;
